import React from "react";

import { StatusBanner } from "@/components/feature/StatusBanner";

/**
 * Fehlermeldung nach einer Aktion im Task Pane.
 *
 * Ein einziger Text für jeden Fehler half niemandem: "Termin konnte nicht
 * erstellt werden" stand auch dann da, wenn der Termin längst angelegt und nur
 * die Einladung nicht verschickt war — der Support konnte aus der Rückmeldung
 * nicht ablesen, wo er suchen muss. Titel und Hinweis richten sich deshalb
 * danach, was tatsächlich gescheitert ist, und `detail` trägt die technische
 * Ursache, die in ein Ticket gehört.
 */
const CASES = {
  create: {
    title: "Termin konnte nicht erstellt werden",
    text: "Der Termin wurde in ePortier nicht angelegt, es ging keine Einladung raus.",
  },
  mail: {
    title: "Einladung konnte nicht versendet werden",
    text: "Der Termin ist in ePortier angelegt — nur die E-Mail an die Besucher ging nicht raus.",
  },
  update: {
    title: "Änderungen konnten nicht gespeichert werden",
    text: "Der Termin bleibt so bestehen, wie er zuletzt gespeichert wurde.",
  },
  delete: {
    title: "Termin konnte nicht gelöscht werden",
    text: "Der Termin ist in ePortier weiterhin vorhanden.",
  },
  outlook: {
    title: "Termin konnte in Outlook nicht gespeichert werden",
    text: "Ohne gespeicherten Outlook-Termin lässt sich keine Einladung erstellen.",
  },
};

const AppointmentFailed = ({ kind = "create", detail }) => {
  const { title, text } = CASES[kind] || CASES.create;

  return (
    <StatusBanner tone="danger" title={title} className="mt-[1.2rem]">
      <p className="m-0">{text} Bitte erneut versuchen.</p>
      {/* `select-all` macht die Zeile mit einem Klick markierbar — sie ist zum
          Weiterreichen an den Support da. */}
      {detail && (
        <p className="m-0 mt-[0.6rem] text-[1.15rem] break-words select-all">
          Meldung für den Support: {detail}
        </p>
      )}
    </StatusBanner>
  );
};

export default AppointmentFailed;
